import create, {initializeAndRegisterHooks} from 'context/create' 
import hooks, * as resolves from './hooks'

const initialState = {
  status: false,
  statusMap: {},
  homework: undefined,
  homeworkLoaded: false,
  homeworks: undefined,
  refreshHomeworks: 0,
  refreshHomework: 0
}

const id = 'Homework'
const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, hooks, resolves)})

export {context as default}
